module.exports = __webpack_public_path__ + "media/page-6.1e0ae83d.mp3";